import { render } from "./ExitConfirmForm.vue?vue&type=template&id=e2d6b76c"
import script from "./ExitConfirmForm.vue?vue&type=script&lang=js"
export * from "./ExitConfirmForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__